import { acceptApprovalRequest, rejectApprovalRequest } from '@wix/ambassador-agentmaker-approvals-v1-approval-request/http';
import { useEffect, useState } from 'react';
import { ModuleRegistry } from 'react-module-container';
import { ModalId, ModuleEvent, RunTaskWidgetSideEffect } from '../constants';
export function useApprovals(_ref) {
  let {
    context
  } = _ref;
  const [resolvedApprovalIds, setResolvedApprovalIds] = useState(new Set());
  const [isEditing, setIsEditing] = useState(false);
  const {
    webActions,
    emitSideEffect
  } = context;
  const httpClient = context.httpClient;
  const addResolvedApprovalId = approvalId => {
    setResolvedApprovalIds(prevResolvedApprovalIds => {
      const newResolvedApprovalIds = new Set(prevResolvedApprovalIds);
      newResolvedApprovalIds.add(approvalId);
      return newResolvedApprovalIds;
    });
  };
  const removeResolvedApprovalId = approvalId => {
    setResolvedApprovalIds(prevResolvedApprovalIds => {
      const newResolvedApprovalIds = new Set(prevResolvedApprovalIds);
      newResolvedApprovalIds.delete(approvalId);
      return newResolvedApprovalIds;
    });
  };
  useEffect(() => {
    const editApprovalCanceledListener = ModuleRegistry.addListener(ModuleEvent.EditApprovalCanceled, () => {
      setIsEditing(false);
    });
    const editApprovalAcceptedListener = ModuleRegistry.addListener(ModuleEvent.EditApprovalAccepted, approvalId => {
      addResolvedApprovalId(approvalId);
      setIsEditing(false);
    });
    const editApprovalRejectedListener = ModuleRegistry.addListener(ModuleEvent.EditApprovalRejected, approvalId => {
      addResolvedApprovalId(approvalId);
      setIsEditing(false);
    });
    return () => {
      editApprovalCanceledListener.remove();
      editApprovalAcceptedListener.remove();
      editApprovalRejectedListener.remove();
    };
  }, []);
  const editApproval = async _ref2 => {
    let {
      approvalId,
      title,
      biOrigin
    } = _ref2;
    setIsEditing(true);
    webActions == null || webActions.bmOpenModal == null || webActions.bmOpenModal({
      componentId: ModalId.EditApproval,
      componentParams: {
        approvalId,
        title,
        biOrigin
      }
    });
  };
  const acceptApproval = async _ref3 => {
    let {
      approvalId,
      invocationId
    } = _ref3;
    addResolvedApprovalId(approvalId);
    try {
      await httpClient.request(acceptApprovalRequest({
        approvalRequestId: approvalId
      }));
      emitSideEffect(RunTaskWidgetSideEffect.Approved, {
        invocationId: invocationId,
        approvalId
      });
    } catch {
      removeResolvedApprovalId(approvalId);
    }
  };
  const rejectApproval = async _ref4 => {
    let {
      approvalId,
      invocationId
    } = _ref4;
    addResolvedApprovalId(approvalId);
    try {
      await httpClient.request(rejectApprovalRequest({
        approvalRequestId: approvalId
      }));
      emitSideEffect(RunTaskWidgetSideEffect.Rejected, {
        invocationId: invocationId,
        approvalId
      });
    } catch {
      removeResolvedApprovalId(approvalId);
    }
  };
  return {
    resolvedApprovalIds,
    isEditing,
    editApproval,
    acceptApproval,
    rejectApproval
  };
}
//# sourceMappingURL=useApprovals.js.map